
export default function LogoSm({...props}) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 271 271" {...props}>
          <g data-name="Group 119" transform="translate(-2437 -1679)">
            <circle
              data-name="Ellipse 20"
              cx={135.5}
              cy={135.5}
              r={135.5}
              transform="translate(2437 1679)"
              fill="#1a1b41"
            />
            <g data-name="Group 116" transform="translate(2520.092 1741.49)">
              <ellipse
                data-name="Ellipse 22"
                cx={87.5}
                cy={88}
                rx={87.5}
                ry={88}
                transform="translate(-.092 -.49)"
                fill="#baff29"
              />
              <g
                data-name="Ellipse 23"
                transform="translate(43.908 43.51)"
                fill="#fff"
                stroke="#1a1b41"
              >
                <ellipse cx={43.5} cy={44} rx={43.5} ry={44} stroke="none" />
                <ellipse cx={43.5} cy={44} rx={43} ry={43.5} fill="none" />
              </g>
            </g>
          </g>
        </svg>
      )
}

export function LogoSmDark({...props}){

    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 271 271"  {...props}>
            <g data-name="Group 119">
                <path
                data-name="Path 106"
                d="M135.5 0A135.5 135.5 0 110 135.5 135.5 135.5 0 01135.5 0z"
                fill="#baff29"
                />
                <g data-name="Group 116" transform="translate(83.092 62.49)">
                <ellipse
                    data-name="Ellipse 22"
                    cx={87.5}
                    cy={88}
                    rx={87.5}
                    ry={88}
                    transform="translate(-.092 -.49)"
                    fill="#1a1b41"
                />
                <g
                    data-name="Ellipse 23"
                    transform="translate(43.908 43.51)"
                    fill="#fff"
                    stroke="#1a1b41"
                >
                    <ellipse cx={43.5} cy={44} rx={43.5} ry={44} stroke="none" />
                    <ellipse cx={43.5} cy={44} rx={43} ry={43.5} fill="none" />
                </g>
                </g>
            </g>
        </svg>
      )

}